import type React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { Button } from '@lb-service/ui';
import { useRouter } from 'next/router';
import appUtils from '../../../../utils/appUtils';

const renderHeroTitle = (t: any) => {
  return { __html: t('service.home.hero.title') };
};

interface Props {
  backgroundClass?: string;
}

const HomeHero: React.FC<Props> = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { locale } = router;
  return (
    <div className="hero">
      <div className="hero-content max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-6xl lg:px-8">
        <div className="w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left side - Text content */}
            <div className="order-2 lg:order-1">
              <h1 className="font-serif">
                <div dangerouslySetInnerHTML={renderHeroTitle(t)} />
              </h1>
              <h2 className="mb-10">
                <span>{t('service.home.hero.intro1')}</span>{' '}
                <span>{t('service.home.hero.intro2')}</span>
              </h2>
              <Button
                asChild
                size="lg"
                className="bg-[#e55425] hover:bg-[#d14a1f] text-white px-8 py-3 text-base font-medium rounded-md transition-colors"
              >
                <Link href={appUtils.getAppPath(locale, 'signup')}>
                  {t('links.signup')}
                </Link>
              </Button>
            </div>
            {/* Right side - Illustration */}
            <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
              <Image
                src="/images/hero-illustration.png"
                alt="Online English learning"
                width={480}
                height={480}
                className="w-full max-w-md lg:max-w-lg h-auto rounded-xl"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default HomeHero;
